<template>
<div>
	<div class="wrap"   @click="dialogVisible=true">
		<cardHead title='农资态势' ></cardHead>
		<div class="card-body">
			<div class="card-body-left">
				<span class="item-value">401.5</span>
				<span class="item-label">库存数量(吨)</span>
			</div>
			<div class="card-body-right">
				<div class="card-item">
					<div class="line bggreen">
						
					</div>
					<div class="card-item-content">
						<span class="item-label">采购数量</span>
						<span class="item-value">2630.5 <i class="unit">吨</i> </span>
						
					</div>
				</div>
				<div class="card-item">
					<div class="line bgpurple">
						
					</div>
					<div class="card-item-content">
						<span class="item-label">消耗数量</span>
						<span class="item-value">2229 <i class="unit">吨</i> </span>
						
					</div>
				</div>
				<div class="card-item">
					<div class="line bgyellow">
						
					</div>
					<div class="card-item-content">
						<span class="item-label">配方数量</span>
						<span class="item-value">45 <i class="unit">个</i> </span>
						
					</div>
				</div>
				<div class="card-item">
					<div class="line bgblue">
						
					</div>
					<div class="card-item-content">
						<span class="item-label">可饲养天数</span>
						<span class="item-value">90  <i class="unit">天</i> </span>
						
					</div>
				</div>
			</div>
		</div>
	
			

		
	</div>
	<propertyModel :dialogVisible='dialogVisible'></propertyModel>
</div>
</template>

<script>
	import cardHead from './cardHead.vue'
	import propertyModel from './propertyModel.vue'
	export default {
	
		components:{
			cardHead,propertyModel
		},
		data() {
			return {
				dialogVisible:false
			};
		},
		async created() {
			
		},
		
		methods: {
			
			
	
		},
	};
</script>

<style lang="scss" scoped>

	.wrap{
		width: 5rem;
		height: 3.13rem;
		background: url('../../../assets/yq/rectangle2.png');
		background-size: contain;
		display:flex;
		cursor: pointer;
		flex-direction: column;
		.card-body{
			flex: 1;
			display: flex;
			    align-items: center;
			.card-body-left{
				width: 2.11rem;
				height: 1.39rem;
				background: url('../../../assets/yq/triangle.png');
				background-size: contain;
				margin-left: -0.1rem;
				background-position:bottom;
				background-repeat: no-repeat;
				display: flex;
				    flex-direction: column;
				    align-items: center;
				
				.item-label{
					font-size: 0.15rem;
					font-family: Source Han Sans CN-Regular, Source Han Sans CN;
					font-weight: 400;
					color: #FFFFFF;
				}
				.item-value{
					margin-bottom: 0.1rem;
					font-size: 0.33rem;
					font-family: Impact-Regular, Impact;
					font-weight: 400;
					color: #00FEFF;
				}
			}
			.card-body-right{
				flex: 1;
				display: flex;
				flex-wrap: wrap;
				height: 100%;
				    justify-content: space-around;
				    align-items: center;
				
				.card-item{
					width: 50%;
					display: flex;
					align-items: center;
					.line{
						width: 0.08rem;
						height: 0.38rem;
						// background: #00E0DB;
						border-radius: 1.25rem 1.25rem 1.25rem 1.25rem;
						margin-right: 0.11rem;
					}
					.card-item-content{
						display: flex;
						flex-direction: column;
						font-size: 0.15rem;
						font-family: Source Han Sans CN-Regular, Source Han Sans CN;
						font-weight: 400;
						color: #FFFFFF;
						.item-label{
							
						}
						.item-value{
							font-size: 0.2rem;
							font-family: Source Han Sans CN-Medium, Source Han Sans CN;
							font-weight: 500;
							color: #00FEFF;
							margin-top: 0.06rem;
						}
					}
				}
			}
		}
			
	}
</style>